/**
 * auditoria.ts — Auditoria de documentos (F10).
 */

import type { components } from './generated/api'
import { api } from './http'

export type AuditoriaResumo = components['schemas']['AuditoriaResumo']
export type RelatorioAuditoria = components['schemas']['RelatorioAuditoria']
export type Apontamento = components['schemas']['Apontamento']
export type DocumentosDetectados = components['schemas']['DocumentosDetectados']
export type AnaliseForense = components['schemas']['AnaliseForense']
export type InformacoesGerais = components['schemas']['InformacoesGerais']

export function listarAuditorias() {
  return api<{ auditorias: AuditoriaResumo[] }>('/api/v1/auditorias')
}

export function relatorioAuditoria(id: number) {
  return api<RelatorioAuditoria>(`/api/v1/auditorias/${id}`)
}

export function documentosDetectados(id: number) {
  return api<DocumentosDetectados>(`/api/v1/auditorias/${id}/documentos`)
}

export function excluirAuditoria(id: number) {
  return api<{ removido: boolean }>(`/api/v1/auditorias/${id}`, {
    method: 'DELETE',
  })
}

export type ConfiguracaoAuditoria = components['schemas']['ConfiguracaoAuditoria']
export type DecretoMunicipal = components['schemas']['DecretoMunicipal']
export type SelecaoAuditoria = components['schemas']['SelecaoAuditoria']
export type ArquivoDetectado = components['schemas']['ArquivoDetectado']
export type TipoDocumento = components['schemas']['TipoDocumento']
export type GeracaoAuditoria = components['schemas']['GeracaoAuditoria']
export type DocumentoSelecionado =
  components['schemas']['DocumentoSelecionadoInput']

export function configuracaoAuditoria() {
  return api<ConfiguracaoAuditoria>('/api/v1/auditoria/configuracao')
}

export function decretosDoMunicipio(municipio: string) {
  return api<{ decretos: DecretoMunicipal[] }>(
    `/api/v1/auditoria/decretos?municipio=${encodeURIComponent(municipio)}`,
  )
}

export interface NovaAuditoria {
  arquivos: File[]
  /** tipo classificado pelo usuário, na MESMA ordem dos arquivos */
  tipos: string[]
  fase: string
  municipio: string
  decretos: number[]
  decretosNovos: File[]
}

export function criarAuditoria(dados: NovaAuditoria) {
  const form = new FormData()
  dados.arquivos.forEach((a) => form.append('documentos', a))
  dados.tipos.forEach((t) => form.append('tipos', t))
  form.append('fase', dados.fase)
  form.append('municipio', dados.municipio)
  dados.decretos.forEach((d) => form.append('decretos', String(d)))
  dados.decretosNovos.forEach((d) => form.append('decretos_novos', d))
  return api<GeracaoAuditoria>('/api/v1/auditorias', { method: 'POST', form })
}

export function selecaoAuditoria(id: number) {
  return api<SelecaoAuditoria>(`/api/v1/auditorias/${id}/selecao`)
}

export function iniciarAuditoria(
  id: number,
  documentos: DocumentoSelecionado[],
  escopoQualitativo: 'focused' | 'global',
  escopoContradicao: 'focused' | 'global',
) {
  return api<GeracaoAuditoria>(`/api/v1/auditorias/${id}/iniciar`, {
    method: 'POST',
    body: {
      documentos,
      escopo_qualitativo: escopoQualitativo,
      escopo_contradicao: escopoContradicao,
    },
  })
}
